// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-input-area {
    display: block;
    position: relative;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    --color-border-form: #666;
    --color-background-container: #fff;
    --color-text-disabled: #c5c5c5;
    --color-interactive-primary-focus: #2a7fb7;
    --color-interactive-primary-default: #1773b0;
    --color-border-disabled: #d1d1d1;
    font-family: Inter, "Helvetica Neue", Helvetica, arial, sans-serif;
    font-size: 14px;
    margin-bottom: 20px;
}

.aims-asking-wrapper {
    height: 32px;
    background: #F5F5F5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
}

.aims-tag-wrap {
    display: flex;
    margin-right: 80px;
}

.aims-file-loader-wrap {
    position: relative;
    top: 2px;
    margin-left: 8px;
}

.aims-asking-message {
    color: #666;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.2px;
}

.input-box {
    margin-bottom: 16px;
    border: 1px solid var(--color-border-form);
    background-color: var(--color-background-container);
}

.input-box:focus-within {
    border: 1px solid var(--color-interactive-primary-focus);
}

.input-area {
    padding: 0 0 0 16px;
    position: relative;
}

.input-area--short {
    padding: 0 90px 0 16px;
}

.aims-textarea {
    border: none;
    padding: 0;
    margin: 14px 16px 0 0;
    width: calc(100% - 16px);
    height: 16px;
    max-height: 128px;
    resize: none;
    font-family: Inter, "Helvetica Neue", Helvetica, arial, sans-serif;
    font-size: 14px;
}

.aims-textarea:disabled {
    background-color: transparent;
    color: var(--color-text-disabled);
}

.aims-textarea:focus {
    outline: none;
}

.input-box:not(.click-focus) .input-area {
    position: relative;
}

.input-box.click-focus:focus-within {
    border-color: var(--color-interactive-primary-default);
}

.input-box.disabled {
    border-color: var(--color-border-disabled);
}

.aims-file-upload-img {
    height: 20px;
}

.aims-actions-wrap {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 16px);
    padding-left: 16px;
    padding-bottom: 4px;
    padding-top: 8px;
}

.aims-actions-wrap-multiline-textarea {
    min-height: 30px;
    padding-bottom: 4px;
    padding-top: 8px;
}

.actions-box-inner {
    display: inline-flex;
    gap: 12px;
    margin-right: 4px;
    justify-content: space-between;
    position: absolute;
    right: 12px;
    bottom: 9px;
    height: 24px;
}

.actions-box campfire-enterprise-button-group {
    display: flex;
}

.aims-actions-box-divider {
    border: .5px solid #E6E6E6;
    height: 16px;
    margin-top: 2px;
    box-sizing: border-box;
}

.aims-files {
    margin: 0px 16px 16px;
}`, "",{"version":3,"sources":["webpack://./src/style/chat-input.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;IAClC,8BAA8B;IAC9B,0CAA0C;IAC1C,4CAA4C;IAC5C,gCAAgC;IAChC,kEAAkE;IAClE,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,mDAAmD;AACvD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kEAAkE;IAClE,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".chat-input-area {\n    display: block;\n    position: relative;\n    border: none;\n    background-color: transparent;\n    box-sizing: border-box;\n    --color-border-form: #666;\n    --color-background-container: #fff;\n    --color-text-disabled: #c5c5c5;\n    --color-interactive-primary-focus: #2a7fb7;\n    --color-interactive-primary-default: #1773b0;\n    --color-border-disabled: #d1d1d1;\n    font-family: Inter, \"Helvetica Neue\", Helvetica, arial, sans-serif;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.aims-asking-wrapper {\n    height: 32px;\n    background: #F5F5F5;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n}\n\n.aims-tag-wrap {\n    display: flex;\n    margin-right: 80px;\n}\n\n.aims-file-loader-wrap {\n    position: relative;\n    top: 2px;\n    margin-left: 8px;\n}\n\n.aims-asking-message {\n    color: #666;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    letter-spacing: 0.2px;\n}\n\n.input-box {\n    margin-bottom: 16px;\n    border: 1px solid var(--color-border-form);\n    background-color: var(--color-background-container);\n}\n\n.input-box:focus-within {\n    border: 1px solid var(--color-interactive-primary-focus);\n}\n\n.input-area {\n    padding: 0 0 0 16px;\n    position: relative;\n}\n\n.input-area--short {\n    padding: 0 90px 0 16px;\n}\n\n.aims-textarea {\n    border: none;\n    padding: 0;\n    margin: 14px 16px 0 0;\n    width: calc(100% - 16px);\n    height: 16px;\n    max-height: 128px;\n    resize: none;\n    font-family: Inter, \"Helvetica Neue\", Helvetica, arial, sans-serif;\n    font-size: 14px;\n}\n\n.aims-textarea:disabled {\n    background-color: transparent;\n    color: var(--color-text-disabled);\n}\n\n.aims-textarea:focus {\n    outline: none;\n}\n\n.input-box:not(.click-focus) .input-area {\n    position: relative;\n}\n\n.input-box.click-focus:focus-within {\n    border-color: var(--color-interactive-primary-default);\n}\n\n.input-box.disabled {\n    border-color: var(--color-border-disabled);\n}\n\n.aims-file-upload-img {\n    height: 20px;\n}\n\n.aims-actions-wrap {\n    display: flex;\n    justify-content: space-between;\n    width: calc(100% - 16px);\n    padding-left: 16px;\n    padding-bottom: 4px;\n    padding-top: 8px;\n}\n\n.aims-actions-wrap-multiline-textarea {\n    min-height: 30px;\n    padding-bottom: 4px;\n    padding-top: 8px;\n}\n\n.actions-box-inner {\n    display: inline-flex;\n    gap: 12px;\n    margin-right: 4px;\n    justify-content: space-between;\n    position: absolute;\n    right: 12px;\n    bottom: 9px;\n    height: 24px;\n}\n\n.actions-box campfire-enterprise-button-group {\n    display: flex;\n}\n\n.aims-actions-box-divider {\n    border: .5px solid #E6E6E6;\n    height: 16px;\n    margin-top: 2px;\n    box-sizing: border-box;\n}\n\n.aims-files {\n    margin: 0px 16px 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
